import { useCallback, useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserId } from 'src/app/shared/hooks/session';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

export function useGetShareTrackingData(): ShareActionsOptions<ShareChannel>['getTrackingData'] {
	const userId = useCurrentUserId();
	const sourceLocation = useQueryParamValue('source_location');
	const {
		data: {
			petition: { id, user, photo, bestShareVisual },
		},
	} = usePsfPromoteOrSharePageData();

	const commonTrackingData = useMemo(
		() => ({
			context: 'psf_promote_or_share',
			view_context: 'psf_promote_or_share',
			source_location: sourceLocation,
			petition_id: `petition_${id}`,
			own_petition: userId === user.id,
			showImage: !!photo,
			recruiter_by_id: userId || undefined,
			is_share_asset: !!bestShareVisual?.url,
		}),
		[sourceLocation, id, userId, user.id, photo, bestShareVisual?.url],
	);

	return useCallback(
		(_channel: ShareChannel) => {
			switch (_channel) {
				default:
					return commonTrackingData;
			}
		},
		[commonTrackingData],
	);
}
